import React from 'react';
import { useConfig } from '../../contexts/ConfigContext';

interface ConfigLoadingProps {
  children: React.ReactNode;
}

export const ConfigLoading: React.FC<ConfigLoadingProps> = ({ children }) => {
  const { isLoading, error } = useConfig();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-500">
          <h2 className="text-xl font-bold mb-2">Configuration Error</h2>
          <p>{error.message}</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
